/**
 * AdminLogin
 * ----------
 * Handles authentication for all /admin routes. The form performs
 * client-side validation, calls the AuthContext login helper, and
 * redirects to the protected console once authenticated.
 */
import { useState } from 'react';
import { Link as RouterLink, useLocation, useNavigate } from 'react-router-dom';
import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Alert from '@mui/material/Alert';
import Divider from '@mui/material/Divider';
import Link from '@mui/material/Link';
import {
  GoogleSignIn
} from "m34n-ui";

const AdminLogin = () => {
  const [formState, setFormState] = useState({ email: '', password: '' });
  const [localError, setLocalError] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: 'radial-gradient(circle at top, rgba(60,31,255,0.25), rgba(6,8,36,0.95))',
        display: 'flex',
        alignItems: 'center',
        py: 8,
      }}
    >
      <Container maxWidth="sm">
        <Paper
          elevation={6}
          sx={{
            p: { xs: 4, md: 6 },
            borderRadius: 4,
            backdropFilter: 'blur(12px)',
            backgroundColor: 'rgba(6,8,36,0.85)',
          }}
        >
          <Stack spacing={3}>
            <Box>
              <Typography variant="overline" color="primary.light" sx={{ letterSpacing: '0.3em' }}>
                ADMIN ACCESS
              </Typography>
              <Typography variant="h4" gutterBottom>
                Pluto TV Rage Rooms
              </Typography>
              <Typography color="text.secondary">
                Authenticate with your Pluto TV credentials to unlock schedule management and live session controls.
              </Typography>
            </Box>

            <GoogleSignIn />

            <Divider sx={{ borderColor: 'rgba(244,243,248,0.08)' }} />

            <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="space-between" spacing={1}>
              <Typography variant="body2" color="text.secondary">
                Need access? Contact the Experiential Ops team.
              </Typography>
              <Link component={RouterLink} to="/" underline="hover" color="secondary">
                Back to site
              </Link>
            </Stack>
          </Stack>
        </Paper>
      </Container>
    </Box>
  );
};

export default AdminLogin;